import { SharedState } from '@trello/shared-state';

export type SmartScheduledCardPlannerEvent = {
  id: string;
  start: string;
  end: string;
  duration: number;
  eventId: string;
  title: string;
  durationEditable: true;
  startEditable: true;
};

export const smartScheduledCardsSharedState = new SharedState<{
  [cardId: string]: SmartScheduledCardPlannerEvent;
}>({});
